<template>
  <v-container fluid>
    <div justify="center">
        <v-row justify="center" class="mt-n8">
          <v-icon class="mx-2" size="35px">assured_workload</v-icon>

          <span style="font-size: 34px; color: #616161">Conciliar banco </span>
        </v-row>
        <v-row justify="center" class="mt-n2">
          <span style="color: #616161"
            >Compara los movimientos de dinero registrados en tus bancos con los reportados por tu entidad bancaria
          </span>
        </v-row>
        <v-row justify="center" >
          <v-col cols="12" md="6">
            <v-card height="200">
            <v-card-text       >
              <search-header
          class="mt-6"
                :show_department="false"
                :show_location="false"
                :show_accounts="true"
                :select_week="2"
                :show_payments="false"
                :show_weeks="false"
                :show_refresh="false"
                @dataFilters="pendingTrasactions($event, 1)"
              />
            </v-card-text>
         
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card height="200">
              <v-card-text>
                <v-card>
                  <v-card-title>
                    <v-avatar left>
                      <v-icon>mdi-bank</v-icon>
                    </v-avatar>
                    Conecta tu cuenta bancaria
                  </v-card-title>
                  <v-card-subtitle class="mx-3">
                    Trae de forma automática tus movimientos
                  </v-card-subtitle>
                </v-card>
              </v-card-text>
              <v-divider inset class="mx-auto"></v-divider>
              <v-card-actions class="justify-center">
                <v-btn color="success" @click="dialog = true"
                  >Subir archivo  <v-icon>mdi-upload </v-icon> </v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
   
    <v-row class="mt-6">
      <v-col>
        <v-card >
          <v-row align="center" justify="space-between">
            <v-col class="text-center">
              <div class="mx-1">Saldo última conciliación</div>
              <div class="font-weight-bold">RD$0.0000</div>
            </v-col>
            
            <div class="divider-icon">
              <v-divider vertical></v-divider>
              <v-icon>mdi-plus</v-icon>
              <v-divider vertical></v-divider>
            </div>

            <v-col class="text-center">
              <div>Entradas</div>
              <div class="font-weight-bold text--success">RD$0.0000</div>
            </v-col>

            <div class="divider-icon">
              <v-divider vertical></v-divider>
              <v-icon>mdi-minus</v-icon>
              <v-divider vertical></v-divider>
            </div>

            <v-col class="text-center">
              <div>Salidas</div>
              <div class="font-weight-bold text--error">RD$0.0000</div>
            </v-col>

            <div class="divider-icon">
              <v-divider vertical></v-divider>
              <v-icon>mdi-equal</v-icon>
              <v-divider vertical></v-divider>
            </div>

            <v-col class="text-center">
              <div>Saldo final</div>
              <div class="font-weight-bold">RD$0.0000</div>
            </v-col>

            <v-divider vertical></v-divider>

            <v-col class="text-center">
              <div>Diferencia con el extracto</div>
              <div class="font-weight-bold">RD$0.0000</div>
              <v-btn small color="success" class="mt-2">Perfecto</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

        </v-row>
      </div>
  </v-container>
</template>

<script>
//import Filters from "@/components/FilterBussinesLocations";
import viewInvoices from "@/components/Transactions/ViewInvoicesCxC.vue";
import CheckOutCxC from "@/components/Transactions/CheckOutCxC.vue";
import moment from "moment";
export default {
  components: { viewInvoices, CheckOutCxC },
  data: () => ({
    date: moment().format("YYYY-MM-DD"),
    date2: moment().format("YYYY-MM-DD"),
    step: 2,
    menu: false,
    menu2: false,
    loading: false,
    lasData: null,
    dialogCancelPayment: false,
    type_modal: 0,
    e1: 1,
    types_form: 0,
    laoded: true,
    dialog: false,
    search: "",
    clients: [],
    data_invoices: [],
    data_invoices_pay: [],
    selected: [],
    hasData: false,

    transactions: [],
    all_transactions: [],
    headersTransactions: [
      {
        text: "Id",
        align: "start",
        sortable: false,
        value: "payment_transaction_id",
      },
      {
        text: "Unidad negocio",
        value: "business_unit_description",
      },
      {
        text: "Tipo pago",
        value: "payment_type_name",
      },
      {
        text: "Banco",
        value: "bank_account_description_long",
      },
      {
        text: "Usuario",
        value: "payment_by_name",
      },
      {
        text: "Fecha aplicación",
        value: "payment_date",
      },
      {
        text: "Monto total",
        align: "end",
        value: "payment_transaction_amount",
      },
      {
        text: "Status",
        value: "status_id",
      },
      // { text: "Actions", value: "actions", sortable: false },
    ],
    gruposTransactions: [
      {
        text: "Grupo",
        align: "start",
        sortable: false,
        value: "invoice_payment_id",
      },
      {
        text: "Suplidor",
        value: "entity",
        width: "20%",
      },
      {
        text: "Tipo pago",
        value: "payment_type_name",
      },
      {
        text: "Usuario",
        value: "payment_by_name",
      },
      {
        text: "Monto total",
        align: "end",
        value: "total_amount",
      },
      {
        text: "Status",
        value: "status_id",
      },
      { text: "Actions", value: "actions", sortable: false },
    ],
    selectPayments: null,
    lastData: null,
    selectedClients: [],
    editedIndex: -1,
    editedItem: [],
  }),

  computed: {},

  watch: {
    async types_form(val) {
      this.changeBusiness(this.lastData);
    },
  },

  created() {
    // this.initialize();
  },

  methods: {
    getColor(color) {
      if (color === 1) {
        return "orange";
      }
      if (color === 2) {
        return "green";
      }
      if (color === 3) {
        return "red";
      }
      if (color === 4) {
        return "red";
      }

      return "grey";
    },
    imgBank(bank) {
      return this.getIconBank(bank);
    },
    groupByEntityId(array) {
      if (array === null) {
        return [];
      }
      const grouped = {};
      array.forEach((item) => {
        const entityId = item.entity_id;
        if (!grouped[entityId]) {
          grouped[entityId] = [];
        }
        grouped[entityId].push(item);
      });
      return grouped;
    },
    colorRandom() {
      let r = Math.floor(Math.random() * 256);
      let g = Math.floor(Math.random() * 256);
      let b = Math.floor(Math.random() * 256);

      // Crear cadena de color en formato hexadecimal
      let colorHex = "#" + r.toString(16) + g.toString(16) + b.toString(16);

      return colorHex;
    },

    async pendingTrasactions(data, type) {
      this.loading = true;
      if (data.accountBank != null) {
        this.lasData = data;
        let filter = "";
        if (type === 1) {
          filter = "where invoice_type_id=1 and status_id=1";
          filter +=
            data.accountBank != null
              ? ` and bank_account_id=${data.accountBank}`
              : ``;
          filter +=
            data.payments_id != null
              ? ` and payment_type_id=${data.payments_id}`
              : ``;
        }
        if (type === 2) {
          filter = ` where invoice_type_id=1 and status_id=3`;
        }
        let resultpayments = await this.api_Post(
          "transactions/viewAllPayemnts",
          {
            filters: filter,
          }
        );
        if (resultpayments.status == 200) {
          this.transactions = [];
          this.transactions = await resultpayments.json();
        }
      }
      this.loading = false;
    },
    async get_transactions(data) {
      this.loading = true;
      this.lastData = data;
      let filter = ` where payment_date between '${data.dateStart}' and '${data.dateEnd}' `;
      filter +=
        data.business != null && data.business != 0
          ? ` and business_unit_id=${data.business}`
          : ``;
      filter +=
        data.accountBank != null
          ? ` and bank_account_id=${data.accountBank}`
          : ``;
      filter +=
        data.payments_id != null
          ? ` and payment_type_id=${data.payments_id}`
          : ``;

      let resultTransactions = await this.api_Post(
        "transactions/viewAllTransactionsFilters",
        {
          filters: filter,
        }
      );
      if (resultTransactions.status == 200) {
        this.all_transactions = [];
        this.all_transactions = await resultTransactions.json();
      }

      this.loading = false;
    },

    getDate(item) {
      return moment(item).format("DD/MM/YYYY");
    },

    async goTransation() {
      if (this.lasData != null) {
        if (this.lasData.business === null) {
          this.$toast.warning("Debes elegir una unidad de negocio!");
          return;
        }
        if (this.lasData.payments_id === null) {
          this.$toast.warning("Debes elegir un metodo de pago!");
          return;
        }
        if (this.lasData.accountBank === null) {
          this.$toast.warning("Debes elegir una cuenta de banco!");
          return;
        }
      }
      if (this.selected.length === 0) {
        this.$toast.warning("Debes elegir un grupo");
        return;
      }
      let payments = [];
      for (let item of this.selected) {
        payments.push({ invoice_payment_id: item.invoice_payment_id });
      }

      let data = {
        in_payment_transaction_id: null,
        in_user_id: this.$store.state.auth.user.user.user_id,
        in_business_unit_id: this.lasData.business,
        in_bank_account_id: this.lasData.accountBank,
        in_invoice_payment_type_id: this.lasData.payments_id,
        in_payment_date: this.date,
        in_accounting_date: this.date2,
        in_status_id: 1,
        in_transaction_details: payments,
      };

      const responseRequest = await this.api_Post(
        "transactions/generate_transactions",
        data
      );
      if (responseRequest.status == 200) {
        let data = await responseRequest.json();
        this.get_transactions(this.lastData);
        this.$toast.success("agregado con exito!");
        this.dialog = false;
      } else {
        const error = await responseRequest.json().catch(() => null);
        this.$toast.error(error?.message || "error al registrar la transacion!");
      }
    },
  },
};
</script>

<style scoped>
.text--success {
  color: #4caf50 !important;
}

.text--error {
  color: #f44336 !important;
}

.v-divider {
  margin: 0 !important;
}

.mx-2 {
  margin-left: 8px !important;
  margin-right: 8px !important;
}</style>
